import React from "react";
import Dummy from "../../assets/assets/account.svg";
import Storage from "../../utils/storage";
import { PropTypes } from "prop-types";

const UserStatus = ({ userAppStatus, userAppStatus2, appStatus, status }) => {
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let img = user && user.logo;
  let compImg = user && user.company && user.company.logo;
  let username = user && user.first_name;
  let name = user && user.name;

  return (
    <div>
      <div className="user-info">
        <div className="user-info-image">
          <img src={img || compImg || Dummy} alt="pic" />
        </div>
        <div className="user-info-names">
          <p>Welcome,</p>
          <h2>{name || username}</h2>
          <h4>
            Acceptance Status:
            {userAppStatus === "approved" && userAppStatus2 !== "rejected" && (
              <span className="approved">{userAppStatus}</span>
            )}
            {userAppStatus === "pending" && userAppStatus2 !== "rejected" && (
              <span className="pending">{userAppStatus}</span>
            )}
            {(userAppStatus === "rejected" ||
              userAppStatus2 === "rejected") && (
              <span className="rejected">Rejected</span>
            )}
            {(userAppStatus === "certfication_requirements_in_progress" ||
              userAppStatus2 === "certfication_requirements_in_progress") && (
              <span className="pending">Certification in progress</span>
            )}
            {(appStatus && appStatus.length === 0) ||
              (status && status.length === 0 && (
                <span className="pending">No application yet</span>
              ))}
          </h4>
        </div>
      </div>
    </div>
  );
};

UserStatus.propTypes = {
  userAppStatus: PropTypes.string,
  userAppStatus2: PropTypes.string,
  appStatus: PropTypes.array,
  status: PropTypes.array,
};

export default UserStatus;
